module.exports = __webpack_public_path__ + "img/japan-diseases-of-the-nervous-system-male.f5dfea7b.png";